import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";

import styled from "styled-components";
import { useSelector } from "react-redux";
import { StudyService } from "../../model/study";
import { MyModal } from "../../features/RadConnStyle";

export default function ExternalResulting(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const editRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handdleClose = () => {
    setWinState((p) => ({ ...p, ...{ show: false } }));
  };

  const handdleSave = async () => {
    const oResult = editRef.current.value;

    let lastRet = editRef.current?.value?.replace(/\s*/g, "").length ?? 0;

    if (lastRet <= 0) {
      alert("กรุณาระบุผลอ่าน");
      return;
    }
    setLoading(true);

    let ret = await StudyService.UpdateStudyResult({
      UserInfo: userDetail,
      StudyInfo: winState?.data,
      ReportInfo: { reptype: 5 }, // official resulted
      ResultText: oResult,
    });

    winState.action && winState.action();
    setLoading(false);
    handdleClose();
  };
  return (
    <MyModal show={winState?.show ?? false} size="lg">
      <ModalHeader onHide={handdleClose}></ModalHeader>
      <ModalBody>
        <Form.Control
          style={{ fontFamily: "Times New Roman" }}
          as="textarea"
          rows={20}
          ref={editRef}
          // onChange={onResultChanged}
          // onKeyDown={resultKeyDown}
        ></Form.Control>
      </ModalBody>
      <ModalFooter>
        <div>
          <ButtonThis variant="success" onClick={() => handdleSave()}>
            ส่งบันทึกผล และ ปิดเคส
          </ButtonThis>
          <ButtonThis variant="danger" onClick={() => handdleClose()}>
            ปิด
          </ButtonThis>
        </div>
      </ModalFooter>
    </MyModal>
  );
}

const ButtonThis = styled(Button)`
  margin-inline-start: 5px;
`;
